var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "my_svg__a",
    x1: 24,
    y1: 187.69,
    x2: 937.56,
    y2: 1101.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#70d48c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M616.84 626.53C742 583.44 832.32 465.34 834 325.91A321.39 321.39 0 00514.75 0C335.65-1.48 190 143.25 190 322c0 141.13 90.8 261 217.16 304.53-179.08 36.85-324 166.19-381.42 335.34-10.36 30.5 12.52 62.13 44.73 62.13h883.06c32.21 0 55.09-31.63 44.73-62.13-57.47-169.15-202.34-298.49-381.42-335.34z",
    fill: "url(#my_svg__a)"
  })));
}
export default SvgMy;